import {getUnverifiedToken} from '@sail/data';
import type {StripeContextInput} from '../../../schema/types';
import {API_KEY, ID, TYPE, LIVE_MODE} from './constants';
import type {PlaygroundUnverifiedToken} from './types';

export default function getPlaygroundUnverifiedToken(
  id?: NonNullable<StripeContextInput['id']>,
  liveMode?: NonNullable<StripeContextInput['liveMode']>,
  apiKey?: NonNullable<StripeContextInput['apiKey']>,
): PlaygroundUnverifiedToken {
  return {
    ...getUnverifiedToken(),
    [API_KEY]: apiKey,
    [ID]: id,
    [TYPE]: 'PLAYGROUND',
    [LIVE_MODE]: liveMode,
  };
}
